// Built-in import
import * as React from "react"

import { IProperty, IServerProperty } from "@/store/slices/property"
// External import
import { Stack, Typography, useMediaQuery } from "@mui/material"

// Internal import

import { limitChar } from "@/utils"
import { useTranslation } from "react-i18next"

interface ITitleCardProps {
  item: IServerProperty
}

const TitleCard: React.FC<ITitleCardProps> = ({ item }) => {
  const { title } = item;
  const { t } = useTranslation(["common"])
  const isSmall = useMediaQuery("(max-width: 640px)");
  const isTooSmall = useMediaQuery("(max-width: 600px)");
  return (
    // <Stack
    //   direction="row"
    //   justifyContent={"space-between"}
    //   alignItems="center"
    //   sx={{ minHeight: 20 }}
    // >
    //   <Typography
    //     variant="subtitleBold"
    //     color="text.primary"
    //     sx={{ width: `calc(100% - 120px)` }}
    //   >
    //     {limitChar(item.title, 50)}
    //   </Typography>
    //   {Boolean(item.status) && (
    //     <Tag
    //       title={t(`common:property_status_${item.status}`)}
    //       color={item.status}
    //     />
    //   )}
    // </Stack>
    <Stack
      direction="row"
      justifyContent={"space-between"}
      alignItems="center"
      spacing={1}
    >
      <Typography
        variant="subtitleBold"

        sx={{
          color: "text.primary",
          // paddingBottom: {
          //   xs: title?.length < 33 ? "30px" : "0px", // Extra small screens
          //   sm: title?.length < 33 ? "30px" : "0px", // Small screens
          //   md: title?.length < 52 ? "30px" : "0px", // Medium screens
          //   lg: title?.length < 33 ? "30px" : "0px", // Large screens
          //   xl: title?.length < 33 ? "30px" : "0px", // Extra large screens
          // },
        }}

      >
        {isSmall && !isTooSmall ? limitChar(title, 40) : limitChar(title, 60)}
      </Typography>

    </Stack>
  )
}

export default TitleCard
